<template>
  <div class="search" :class="{ opacity0: departMore == 0 }">
    <ul class="ml20 part03">
      <li class="flex nowrap start" ref="profession">
        <dt class="nowrap title">报名类型：</dt>
        <dd
          class="flex flex1"
          :class="{
            mr50: professionMore > 1,
            'height34px ohide': professionMore == 2,
          }"
        >
          <a :class="{ on: ClassifyID == 0 }" @click="ClassifyID = 0">全部</a>
          <a
            @click="ClassifyID = item.ClassifyID"
            :class="{ on: ClassifyID == item.ClassifyID }"
            v-for="(item, index) in classifyList"
            :key="index"
            >{{ item.ClassifyName }}</a
          >
        </dd>
        <dd
          v-if="professionMore > 1"
          class="absolute r t mt27 Conhover C888 pointer"
        >
          <p v-if="professionMore == 2" @click="professionMore = 3">
            展开 <i class="el-icon-arrow-down"></i>
          </p>
          <p v-if="professionMore == 3" @click="professionMore = 2">
            收起 <i class="el-icon-arrow-up"></i>
          </p>
        </dd>
      </li>
      <li class="flex nowrap start" ref="depart">
        <dt class="nowrap title">报名状态：</dt>
        <dd
          class="flex flex1"
          :class="{ mr50: departMore > 1, 'height34px ohide': departMore == 2 }"
        >
          <a
            @click="StatusID = item.StatusID"
            v-for="(item, index) in typeList"
            :class="{ on: StatusID == item.StatusID }"
            :key="index"
            >{{ item.StatusIDName }}</a
          >
        </dd>
        <dd
          v-if="departMore > 1"
          class="absolute r t mt27 Conhover C888 pointer"
        >
          <p v-if="departMore == 2" @click="departMore = 3">
            展开 <i class="el-icon-arrow-down"></i>
          </p>
          <p v-if="departMore == 3" @click="departMore = 2">
            收起 <i class="el-icon-arrow-up"></i>
          </p>
        </dd>
      </li>
    </ul>
  </div>
</template>

<script>
import { Enroll_GetClassifys } from "@/api/apipcEnroll";
export default {
  name: "apipcEnrollTypeList",
  data() {
    return {
      typeList: [
        { StatusID: 0, StatusIDName: "全部" },
        { StatusID: 1, StatusIDName: "未开始" },
        { StatusID: 2, StatusIDName: "进行中" },
        { StatusID: 3, StatusIDName: "已结束" },
      ],
      StatusID: 0,
      departMore: 0, // 0隐藏  1单行显示 2多行收起 3多行展开
      classifyList: [],
      ClassifyID: 0,
      professionMore: 0,
      OrderBy: 0,
    };
  },
  watch: {
    OrderBy(v) {
      this.$router.replace({
        query: { ...this.$route.query, OrderBy: v },
      });
    },
    StatusID(v) {
      this.$router.replace({
        query: { ...this.$route.query, StatusID: v },
      });
    },
    ClassifyID(v) {
      this.$router.replace({
        query: { ...this.$route.query, ClassifyID: v },
      });
    },
  },
  methods: {},
  async created() {
    let { ClassifyID, StatusID } = this.$route.query;
    if (ClassifyID) {
      ClassifyID = Number(ClassifyID);
      this.ClassifyID = ClassifyID;
    }
    if (StatusID) {
      StatusID = Number(StatusID);
      this.StatusID = StatusID;
    }
    Enroll_GetClassifys().then((res) => {
      this.classifyList = res.data;
    });

    this.$nextTick(() => {
      this.departMore = this.$refs.depart.offsetHeight > 80 ? 2 : 1;
      this.professionMore = this.$refs.profession.offsetHeight > 80 ? 2 : 1;
    }, 50);
  },
};
</script>

<style lang="scss" scoped>
.search {
  margin-top: 30px;
  width: 1760px;
  padding: 0 10px;
  height: 126px;
  background: #ffffff;
  border-radius: 10px;
  font-size: 16PX;
  color: #333333;
  .title {
    padding: 5px 0;
    color: #666666;
    margin-right: 10px;
  }
  .navbar {
    gap: 50px;
    padding-top: 15px;
    margin-left: 15px;
    border-top: 1px solid #e6e6e6;
    .actives {
      color: #1d79ff;
    }
    .navbar-item {
      cursor: pointer;
      img {
        margin-right: 5px;
      }
      .recommend {
        width: 16px;
        height: 15px;
        margin-top: -2px;
      }
      .new {
        width: 25pxx;
        height: 14px;
      }
      .hot {
        width: 22px;
        height: 17px;
      }
    }
  }
}
</style>
